import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import styles from "./DropDown.module.css";

const DropDown = ({ className = "", options = ["USD", "EUR", "GBP"], onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(options[0]);

  const handleToggle = () => setIsOpen(!isOpen);

  const handleSelect = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    if (onSelect) {
      onSelect(option);
    }
  };

  return (
    <Box className={[styles.dropDown, className].join(" ")} onClick={handleToggle}>
      <Box className={styles.selectedOption}>
        <Typography className={styles.label}>{`Currency - ${selectedOption}`}</Typography>
        <span className={styles.icon}></span>
      </Box>
      {isOpen && (
        <Box className={styles.options}>
          {options.map((option) => (
            <Box 
              key={option} 
              className={styles.option} 
              onClick={() => handleSelect(option)}
            >
              {option}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

DropDown.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  onSelect: PropTypes.func,
};

export default DropDown;